import type { EventType } from '@cocoonspace/sdk-js/v2/types/eventType'
import { useCallback } from 'react'
import {
	getGetMeProfileQueryKey,
	useGetMeProfile,
	useUpdateMeProfile,
} from '@cocoonspace/sdk-js/v2/domains/me-profile/me-profile'
import { getListEventTypesQueryKey } from '@cocoonspace/sdk-js/v2/domains/schedulers/schedulers'
import { Switch } from '@cocoonspace/ui/components/switch'
import { useLingui } from '@lingui/react/macro'
import { useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

export const ToggleEnabledAction = ({
	eventType,
	isPublic,
}: {
	eventType: EventType
	isPublic: boolean
}) => {
	const { t } = useLingui()
	const queryClient = useQueryClient()

	const { data: meProfile } = useGetMeProfile()
	const { mutateAsync } = useUpdateMeProfile()

	const toggleEnabled = useCallback(
		(nextChecked: boolean) => {
			const current = meProfile?.eventTypeIds ?? []
			const next = nextChecked
				? Array.from(new Set([...current, eventType.id]))
				: current.filter((id) => id !== eventType.id)

			return mutateAsync({
				data: {
					eventTypeIds: next,
				},
			})
				.then(() => {
					toast.success(t`Type de rendez-vous mis à jour`)

					queryClient.invalidateQueries({
						queryKey: getListEventTypesQueryKey(),
					})

					queryClient.invalidateQueries({
						queryKey: getGetMeProfileQueryKey(),
					})
				})
				.catch(() => {
					toast.error(t`Une erreur est survenue`)
				})
		},
		[meProfile?.eventTypeIds, eventType.id, mutateAsync, t, queryClient],
	)

	return (
		<div className='flex items-center gap-2'>
			<span className='text-muted-foreground text-sm'>
				{isPublic ? t`Publique` : t`Privé`}
			</span>

			<Switch
				checked={isPublic}
				className='ml-auto'
				onCheckedChange={toggleEnabled}
				size='sm'
			/>
		</div>
	)
}
